import { useMatrixVariantsContext } from '@app/components/products/ProductMatrix/context';
import { getVariantsSizes } from '@app/logic/products';

import { RegularHeaderCell } from '../MatrixCells/RegularHeaderCell';

export const InputHeadCells = () => {
  const { variants } = useMatrixVariantsContext();
  const sizes = getVariantsSizes(variants);

  return (
    <>
      {sizes.map(size => (
        <RegularHeaderCell className="rounded-regular text-neutral-60 body-6" key={size}>
          {size}
        </RegularHeaderCell>
      ))}
    </>
  );
};
